import { render, staticRenderFns } from "./pembelian.vue?vue&type=template&id=569b62c3"
import script from "./pembelian.vue?vue&type=script&lang=js"
export * from "./pembelian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports